import { c7Api } from './c7Api';

export interface User {
    Nombre: string;
    Apellido: string;
    Email: string;
    Roles: string;
}

class Usuarios {
    
    private static usuariosInstance: Usuarios;
    private baseUrl:string = "api/usuarios"

    private constructor() { }

    public static GetInstance(): Usuarios {
        if(!Usuarios.usuariosInstance){
            Usuarios.usuariosInstance = new Usuarios();
        }
        return Usuarios.usuariosInstance;
    }

   /* public async GetUsersByName(data:User): Promise<User []>{
        return await c7Api.get(`${this.baseUrl}/${data.nombre}`)//Poner bien el request
    }*/

    
    public async RegisterUser(data:FormData): Promise<any> {    
  return await c7Api.postFormData(this.baseUrl, data);
}


}

  export const usuariosLogic = Usuarios.GetInstance();